import { Typography } from "@mui/material";
import { useJednotkaQuery } from "../api/JsdhNotifikaceService/service/AdminMutations";
import { useElapsedTime } from "../hooks/useElapsedTime";

type Props = {
    casVyhlaseni: string;
    variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

export const CasOdVyhlaseni = ({ casVyhlaseni, variant = 'h1' }: Props) => {
    const { data: jednotka } = useJednotkaQuery();
    const limitMinutes = jednotka?.casVyjezdMinuty || 10;
    const { elapsed, formatted, shouldBlink } = useElapsedTime(casVyhlaseni, limitMinutes);

    return (
        <Typography
            variant={variant}
            sx={{
                fontWeight: "bold",
                fontSize: 'var(--dashboard-timer-size)',
                lineHeight: 1,
                color: elapsed < 0 ? "success.main" : "error.main",
                ...(shouldBlink && {
                    animation: "blink 1s ease-in-out infinite",
                    "@keyframes blink": {
                        "0%, 100%": { opacity: 1 },
                        "50%": { opacity: 0.2 },
                    },
                }),
            }}
        >
            {formatted}
        </Typography>
    );
};
